import React from "react";
import DecisionPenLogo from "../../components/DecisionPenLogo";
import { useV2Theme } from "../theme/ThemeProvider";

/**
 * Centered auth card on v2 neutral-light background.
 * Mobile: top-aligned for long signup forms + safe-area padding.
 */
export default function V2AuthLayout({ title, subtitle, children, wide = false }) {
  const { tokens } = useV2Theme();
  const maxW = wide ? "max-w-lg" : "max-w-md";

  const rootClass = tokens.app.root.replace("min-h-screen", "min-h-dvh");

  return (
    <div className={rootClass}>
      <div className="flex min-h-dvh flex-col items-center justify-start px-4 pt-[max(1rem,env(safe-area-inset-top))] pb-[max(6rem,env(safe-area-inset-bottom))] sm:justify-center sm:py-6">
        <div
          className={`w-full ${maxW} ${tokens.surface.card} px-4 py-5 sm:px-6 shadow-sm`}
        >
          <div className="mb-3 flex justify-center">
            <DecisionPenLogo size={40} className="flex-shrink-0" />
          </div>
          <h1 className="text-center text-xl font-semibold tracking-tight text-slate-900">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-1 text-center text-sm text-slate-500">{subtitle}</p>
          ) : null}
          <div className="mt-5">{children}</div>
        </div>
        <p className="mt-4 text-center text-xs text-slate-500 px-2">
          DecisionPen — Architecture Decision Workspace
        </p>
      </div>
    </div>
  );
}
